import { render, staticRenderFns } from "./status-badge-group.vue?vue&type=template&id=747ed583&"
import script from "./status-badge-group.vue?vue&type=script&lang=js&"
export * from "./status-badge-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports